<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <banner-component
      :allModuleIdBanner="this.allModuleId ? this.allModuleId : ''"
      :jobSeriesBanner="this.assignmentNo ? this.assignmentNo : ''"
      :bannerClientName="
        this.BLRaised.clientName ? this.BLRaised.clientName : ''
      "
      :trackingId="trackingId != '' ? trackingId : ''"
      iconId="fa fa-ship"
    />
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousSalesView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>

          <md-layout md-flex>
            <h2>B/L ( NON-US )</h2>
            <md-layout md-flex="45"></md-layout>
          </md-layout>
        </md-layout>

        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <!-- <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>BL - US </b-navbar-brand>-->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!-- <b-button
                v-if="BLRaised.fclBlId != '' && this.$sessionsStorage.get('designation') == 'Admin' && originalDone==true"
                @click="openNoteModal('1')"
                size="sm"
                variant="warning"
                >Credit Note</b-button
              >
<b-button
style="margin-left: 5px"
                v-if="BLRaised.fclBlId != '' && this.$sessionsStorage.get('designation') == 'Admin' && originalDone==true"
                @click="openNoteModal('2')"
                size="sm"
                variant="warning"
                >Debit Note</b-button
              >
              <b-button
  style="margin-left: 5px"
                v-if="BLRaised.fclBlId!=''"
                @click="openPopMail"
                size="sm"
                variant="warning"
              >Send Pre-Alert Mail</b-button>
              <b-button
                style="margin-left:5px"
                v-if="BLRaised.fclBlId!=''"
                @click="Print(BLRaised.uploadBL)"
                size="sm"
                variant="warning"
              >B/L PDF</b-button>
              <b-button
                style="margin-left:5px"
                @click="downloadWord(BLRaised.fclBlId)"
                v-if="BLRaised.fclBlId!=''"
                size="sm"
                variant="warning"
              >B/L Word</b-button> 
              v-if="BLRaised.fclBlId!='' && selectedConFclBLNonUsId != ''"
              -->
              <!-- <b-button
  style="margin-left: 5px"
                 v-if="BLRaised.conFclBLNonUsId!='' || clientList.length>0"
                @click="openPopMail"
                size="sm"
                variant="warning"
              >Send Pre-Alert Mail</b-button>-->
              <!-- <b-button
                style="margin-left:5px"
                v-if="selectedConFclBLNonUsId != ''"
                variant="warning"
                size="sm"
                class="pull-right"
                id="addButtonLoader"
                @click="proceedToTally"
              >Proceed To Invoice</b-button>-->
              <!-- <b-button
                style="margin-left:5px"
                size="sm"
                v-if="splitBlList.length>0 || allData[0].typeOfBL=='1'"
                @click="deleteAllBL"
                variant="danger"
              >Delete B/L</b-button>-->
              <!-- <b-button
                style="margin-left:5px"
                v-if="billLandingModel.blLandingId!=''"
                variant="warning"
                class="pull-right"
                id="addButtonLoader"
                @click="proceedToTally"
              >Proceed To Invoice</b-button>-->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <div v-if="BLRaised.conFclBLNonUsId != '' || clientList.length > 0">
          <div class="box" v-if="containerDetail.length > 0">
            <div class="box-header">
              <h3 class="box-title">Container Detail</h3>
              <b-button
                v-if="BLRaised.fclBlId != '' && BLRaised.fclBlId != undefined && originalDone==true"
                @click="openPopBLMail"
                size="sm"
                variant="warning"
              >Edit BL Request</b-button>
            </div>
            <hr class="hr-s" />
            <!-- /.box-header -->
            <div class="box-body">
              <table id="clientSB" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>
                          <input 
                            type="checkbox" 
                            v-model="selectAllContainers" 
                            @change="toggleSelectAll"
                            :indeterminate="isIndeterminate"
                          />
                        </th>
                    <th>Container No</th>
                    <th>Container Type</th>
                    <th>Seal No</th>
                    <th>Gross Weight</th>
                    <th>Measurement</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in containerDetail" :key="index">
                    <td>
                          <input 
                            type="checkbox" 
                            v-model="item.selected" 
                            @change="updateSelectAll"
                            :disabled="item.containerWithSplit == 1"
                          />
                        </td>
                    <td>{{ item.containerNo }}</td>
                    <td>{{ item.containerType }}</td>
                    <td>{{ item.customSealNo }}</td>
                    <td>{{ item.grossWeight }}</td>
                    <td>{{ item.measurement }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
                <!-- Container selection controls -->
                <div class="mt-3" v-if="containerDetail.length > 0">
                  <div class="alert alert-info">
                    <strong>Container Selection:</strong> Use the checkboxes to select individual containers or use the controls below for bulk operations. 
                    Selected containers can be used for specific operations. Containers with split status are disabled.
                  </div>
                  
                  <!-- Warning when no containers are selected -->
                  <div v-if="!hasSelectedContainers" class="alert alert-warning">
                    <strong>Warning:</strong> Please select at least one container to proceed.
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <b-button 
                        size="sm" 
                        variant="info" 
                        @click="selectAllContainers = true; toggleSelectAll()"
                        class="mr-2"
                      >
                        Select All
                      </b-button>
                      <b-button 
                        size="sm" 
                        variant="secondary" 
                        @click="selectAllContainers = false; toggleSelectAll()"
                        class="mr-2"
                      >
                        Deselect All
                      </b-button>
                    </div>
                    <div class="col-md-6 text-right">
                      <span class="text-muted">
                        Selected: {{ selectedContainersCount }} of {{ selectableContainersCount }} containers
                      </span>
                    </div>
                  </div>
                </div>
            <!-- /.box-body -->
          </div>

          <hr class="hr-s" />
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <label
                for="fclConsoMultipleClientId"
                v-if="BLRaised.conFclBLNonUsId == ''"
              >Client Name</label>
              <model-list-select
                v-if="BLRaised.conFclBLNonUsId == ''"
                :list="clientList"
                id="fclConsoMultipleClientId"
                v-model="BLRaised.fclConsoMultipleClientId"
                option-value="fclConsoMultipleClientId"
                option-text="clientName"
                placeholder="Select  Client Name"
              ></model-list-select>
              <md-layout md-flex="100" v-else>
                <label for="clientName">Client Name</label>
                <b-form-input :formatter="capitalizeAll" disabled v-model="BLRaised.clientName"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="20">
              <label for="blType">B/L Stage</label>
              <!-- :list="blStageList" -->
              <model-list-select
                @input="checBlstage"
                :list="originalDone==false ?blStageList:blStageListAfterOriginalCreated"
                v-model="BLRaised.blStage"
                option-value="blStageVal"
                option-text="blStageTxt"
                placeholder="Select B/L Stage"
              ></model-list-select>
              <span class="error" v-if="!BLRaised.blStage">
                {{
                errorBLRaised.blStage
                }}
              </span>
            </md-layout>

            <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>B\L Created on</label>

              <date-picker
                v-model="BLRaised.blDate"
                lang="en"
                type="datetime"
                format="YYYY-MM-DD hh:mm "
                :minute-step="1"
                id="acceptanceDate"
              ></date-picker>

            </md-layout>-->

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="30" class="mt-5">
              <label for="blType">B/L Created on</label>
              <date-picker
                v-model="BLRaised.blDate"
                lang="en"
                type="datetime"
                format="YYYY-MM-DD hh:mm "
                :minute-step="1"
                id="acceptanceDate"
              ></date-picker>
            </md-layout>
          </md-layout>

          <!-- <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="clientAddress"
                  name="clientAddress"
                  v-model="BLRaised.clientAddress"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>-->
          <md-layout gutter style="margin-top: 2%">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>CONSIGNOR</label>
            </md-layout>

            <md-layout md-flex="40">
              <label>CONSIGNEE ( OR ORDER)</label>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <!-- <VueTrix v-model="BLRaised.consignor" placeholder="Enter Content"/> -->
                <!-- <div class="quill-editor" v-model="BLRaised.consignor" v-quill:myQuillEditor="{}"></div> -->
                <quill-editor
                  ref="myTextEditor"
                  v-model="BLRaised.consignor"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.consignor">
                {{
                errorBLRaised.consignor
                }}
              </span>
            </md-layout>

            <md-layout md-flex="40">
              <md-layout md-flex="100">
                <quill-editor
                  ref="myTextEditor"
                  v-model="BLRaised.consignee"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.consignee">
                {{
                errorBLRaised.consignee
                }}
              </span>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout
              md-flex="30"
              v-for="(singleInput, index) in BLRaised.notifyList"
              :key="index"
              style="margin-top: 3%"
            >
              <md-layout md-flex="100">
                <md-layout md-flex="15"></md-layout>
                <md-layout md-flex="60">
                  <label>{{ notifyArray[index] }} Notify Party</label>
                </md-layout>
                <md-layout md-flex="15" v-if="index > 1">
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="removeNotify(index)"
                    style="min-height: 20px; height: 20px"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                </md-layout>
              </md-layout>

              <md-layout md-flex="100">
                <md-layout md-flex="15"></md-layout>
                <md-layout md-flex="70">
                  <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor>
                </md-layout>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label class="showMoreData" @click="addNotify">Add Notify</label>
              <md-spinner md-indeterminate id="loader1" style="display: none"></md-spinner>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Bill of Lading No</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="billLading"
                  name="billLading"
                  v-model="BLRaised.billLading"
                  disabled
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.billLading">
                {{
                errorBLRaised.billLading
                }}
              </span>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Shipment Reference Number</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="shippingReferenceNum"
                  name="shippingReferenceNum"
                  v-model="BLRaised.shippingReferenceNum"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.shippingReferenceNum">
                {{
                errorBLRaised.shippingReferenceNum
                }}
              </span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Type of Move</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="typeMove"
                  name="typeMove"
                  v-model="BLRaised.typeMove"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.typeMove">
                {{
                errorBLRaised.typeMove
                }}
              </span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>No. of Original B/L</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="originalBill"
                  name="originalBill"
                  v-model="BLRaised.originalBill"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.originalBill">
                {{
                errorBLRaised.originalBill
                }}
              </span>
            </md-layout>
          </md-layout>

          <!-- <md-layout gutter>
            <md-layout
              md-flex="30"
              v-for="(singleInput, index) in BLRaised.notifyList"
              :key="index"
              style="margin-top:3%"
            >
              <md-layout md-flex="100">
                <md-layout md-flex="10"></md-layout>
                <md-layout md-flex="40">
                  <label>{{singleInput.text}} Notify Party</label>
                </md-layout>
              </md-layout>
              <md-layout md-flex="100">
                <md-layout md-flex="10"></md-layout>
                <md-layout md-flex="60">
                  <quill-editor
                    ref="myTextEditor"
                    v-model="singleInput.inputValue"
                    :options="editorOption"
                  ></quill-editor>
                </md-layout>
              </md-layout>
            </md-layout>
          </md-layout>-->
          <!-- <md-layout md-flex="40">
              <VueTrix v-model="editorContent" placeholder="Enter Content"/>
          </md-layout>-->
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Pre­Carriage By</label>
                <b-form-input :formatter="capitalizeAll" id name v-model="BLRaised.preCarriage"></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.preCarriage">
                {{
                errorBLRaised.preCarriage
                }}
              </span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <label>Place of Acceptance/Date</label>

              <!-- <date-picker
                v-model="BLRaised.acceptanceDate"
                lang="en"
                type="datetime"
                format="YYYY-MM-DD hh:mm "
                :minute-step="1"
                id="acceptanceDate"
              ></date-picker>-->
              <b-form-input
                :formatter="capitalizeAll"
                id="modeMean"
                name="modeMean"
                v-model="BLRaised.acceptanceDate"
              ></b-form-input>
              <span class="error" v-if="!BLRaised.acceptanceDate">
                {{
                errorBLRaised.acceptanceDate
                }}
              </span>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Transport Mode</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="modeMean"
                  name="modeMean"
                  v-model="BLRaised.modeMean"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.modeMean">
                {{
                errorBLRaised.modeMean
                }}
              </span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Vessel/Voy</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="vesselVoy"
                  name="vesselVoy"
                  v-model="BLRaised.vesselVoy"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.vesselVoy">
                {{
                errorBLRaised.vesselVoy
                }}
              </span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Route/Place of Transhipment(If Any</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="routePlace"
                  name="routePlace"
                  v-model="BLRaised.routePlace"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.routePlace">
                {{
                errorBLRaised.routePlace
                }}
              </span>
            </md-layout>
          </md-layout>

          <md-layout gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Port of Loading</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="portLoad"
                  name="portLoad"
                  v-model="BLRaised.portLoad"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.portLoad">
                {{
                errorBLRaised.portLoad
                }}
              </span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Port of Discharge</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="portDischarge"
                  name="portDischarge"
                  v-model="BLRaised.portDischarge"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.portDischarge">
                {{
                errorBLRaised.portDischarge
                }}
              </span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Final Place of Delivery</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="placeDilievery"
                  name="placeDilievery"
                  v-model="BLRaised.placeDilievery"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.placeDilievery">
                {{
                errorBLRaised.placeDilievery
                }}
              </span>
              <!--  -->
            </md-layout>
          </md-layout>
          <hr />
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <!-- <md-layout md-flex="30">
              <label>Container No. / Marks and Nos</label>
            </md-layout>-->
            <md-layout md-flex="85">
              <label>Description of Packages and Goods</label>
            </md-layout>
            <!-- <md-layout md-flex="20">
              <label>No. of Pkgs</label>
            </md-layout>-->
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <!-- <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor
                  ref="myTextEditor"
                  v-model="BLRaised.containerMarks"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.containerMarks">{{errorBLRaised.containerMarks}}</span>
            </md-layout>-->
            <md-layout md-flex="60">
              <md-layout md-flex="100">
                <!-- <b-form-textarea :formatter="capitalizeAll"
                  id="remark"
                  style="height:100px"
                  name="remark"
                  v-model="BLRaised.descriptionGood"
                ></b-form-textarea>-->
                <quill-editor
                  ref="myTextEditor"
                  style="width: 900px !important"
                  v-model="BLRaised.descriptionGood"
                  :options="editorOption"
                ></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.descriptionGood">
                {{
                errorBLRaised.descriptionGood
                }}
              </span>
            </md-layout>

            <!-- <md-layout md-flex="10">
              <md-layout md-flex="100">
                <quill-editor ref="myTextEditor" v-model="BLRaised.noPkg" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.noPkg">{{errorBLRaised.noPkg}}</span>
            </md-layout>-->
          </md-layout>

          <!-- <md-layout gutter style="margin-top:2%">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>Gross Weight</label>
            </md-layout>

            <md-layout md-flex="30">
              <label>Net Weight</label>
            </md-layout>
            <md-layout md-flex="30">
              <label>Measurement</label>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.grossWeight" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.grossWeight">{{errorBLRaised.grossWeight}}</span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.netWeight" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.netWeight">{{errorBLRaised.netWeight}}</span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.measurement" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.measurement">{{errorBLRaised.measurement}}</span>
            </md-layout>
          </md-layout>-->
          <md-layout gutter style="margin-top: 2%">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label>Description of Charges</label>
            </md-layout>
            <md-layout md-flex="30">
              <label>Prepaid</label>
            </md-layout>

            <md-layout md-flex="30">
              <label>Collect</label>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <md-layout md-flex="100">
                  <quill-editor v-model="BLRaised.desCharges" :options="editorOption"></quill-editor>
                </md-layout>
              </md-layout>
              <span class="error" v-if="!BLRaised.desCharges">
                {{
                errorBLRaised.desCharges
                }}
              </span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.prepaid" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.prepaid">
                {{
                errorBLRaised.prepaid
                }}
              </span>
            </md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <quill-editor v-model="BLRaised.collect" :options="editorOption"></quill-editor>
              </md-layout>
              <span class="error" v-if="!BLRaised.collect">
                {{
                errorBLRaised.collect
                }}
              </span>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="blType">Place</label>
              <!-- <model-list-select
                :list="PlaceList"
                v-model="BLRaised.placeBranch"
                option-value="PlaceVal"
                option-text="PlaceTxt"
                placeholder="Select Pridel Branch Name"
              ></model-list-select>-->

              <model-list-select
                :list="PlaceListNew"
                v-model="BLRaised.placeBranch"
                option-value="pickupLocation"
                option-text="pickupLocation"
                placeholder="Select Pridel Branch Name"
              ></model-list-select>
              <span class="error" v-if="!BLRaised.placeBranch">
                {{
                errorBLRaised.placeBranch
                }}
              </span>
            </md-layout>

            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <label for="blType">Delievery Agent</label>
              <model-list-select
                :list="AgentList"
                @input="getAgentName"
                v-model="BLRaised.delieveryAgent"
                option-value="agntColoaderId"
                option-text="agentName"
                placeholder="Select Delievery Agent"
              ></model-list-select>
              <span class="error" v-if="!BLRaised.delieveryAgent">
                {{
                errorBLRaised.delieveryAgent
                }}
              </span>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Total</label>
                <b-form-input
                  :formatter="capitalizeAll"
                  id="total"
                  name="total"
                  v-model="BLRaised.total"
                ></b-form-input>
              </md-layout>
              <span class="error" v-if="!BLRaised.total">
                {{
                errorBLRaised.total
                }}
              </span>
            </md-layout>
          </md-layout>
          <h3
            v-if="BLRaised.blStage=='ORIGINAL'"
            class="error mt-3"
          >BL Will Be Uneditable Once ORIGINAL BL Is Created</h3>

          <hr class="hr-s" />
          <md-layout md-gutter class="mrgtop-2per">
            <md-layout md-flex="40"></md-layout>
            <md-layout md-flex="20">
              <md-button
                :disabled="savegenerateblprealertStatus == true ? true : false"
                class="md-raised md-primary md-button-color heght-1px"
                id="addButtonLoader"
                @click="addBLRaised"
              >Submit</md-button>
              <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
            </md-layout>
          </md-layout>
        </div>
        <h5 v-if="BLRaised.CreatedBY">
          <span
            class="error"
          >Created/Updated = {{" "+BLRaised.CreatedBY + " -- " +BLRaised.createUpdate}}</span>
        </h5>
        <hr class="hr-s" />

        <div class="box" v-if="nonUsBlTable.length > 0">
          <div class="box-header">
            <h3 class="box-title">Client BL Details</h3>
            <!-- v-if="noteModal.fclBlId != '' && this.$sessionsStorage.get('designation') == 'Admin' && originalDone==true" -->
            <!-- <b-button
                v-if="BLRaised.fclBlId != '' && BLRaised.fclBlId != undefined && originalDone==true"
                @click="openPopBLMail"
                size="sm"
                variant="warning"
                >Edit BL Request</b-button
            >-->
            <b-button
              style="margin-left: 5px"
              v-if="
                BLRaised.fclBlId != '' && BLRaised.fclBlId != undefined &&
                (this.$sessionsStorage.get('designation') == 'Admin' ||
                  this.$sessionsStorage.get('userId') == '110')&& originalDone==true
              "
              @click="openNoteModal(2)"
              size="sm"
              variant="warning"
            >Debit Note</b-button>
            <b-button
              style="margin-left: 5px"
              v-if="
                BLRaised.fclBlId != '' && BLRaised.fclBlId != undefined &&
                (this.$sessionsStorage.get('designation') == 'Admin' ||
                  this.$sessionsStorage.get('userId') == '110')&& originalDone==true
              "
              @click="openNoteModal(1)"
              size="sm"
              variant="warning"
            >Credit Note</b-button>

            <b-button
              style="margin-left: 5px"
              @click="openPreAlert"
              size="sm"
              variant="warning"
            >Pre Alert Mail</b-button>
            <Filter-Agency-Modal />
             <FilterCBModal />
             <ClientCard />
              <ShipmentTrackCard />
          </div>
          <hr class="hr-s" />
          <!-- /.box-header -->
          <div class="box-body">
            <table id="clientSB" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Client Name</th>
                  <th>BL Stage</th>
                  <th>Print</th>
                  <th>Download Word</th>
                  <th>Proceed to Invoice</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in nonUsBlTable" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td class="showMoreData" @click="viewEditBLNonUs(item)">{{ item.clientName }}</td>
                  <td>{{ item.blStage }}</td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="Print(item.uploadBLCon)"
                    >
                      <md-icon>print</md-icon>
                    </md-button>
                  </td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="downloadWord(item.conFclBLNonUsId)"
                    >
                      <md-icon>cloud_download</md-icon>
                    </md-button>
                  </td>
                  <td>
                    <md-button
                      class="md-button md-raised md-dense"
                      @click="
                        proceedToTallyByClient(
                          item.conFclBLNonUsId,
                          item.InvTallyId,
                          item.clientName
                        )
                      "
                    >
                      <!-- <md-icon>invoice</md-icon> -->
                      Invoice
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>

        <hr class="hr-s" v-if="BLRaised.conFclBLNonUsId == '' && clientList.length == 0" />
        <md-layout
          md-gutter
          class="mrgtop-2per"
          v-if="BLRaised.conFclBLNonUsId == '' && clientList.length == 0"
        >
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="20">
            <md-button
              class="md-raised md-primary md-button-color heght-1px"
              id="addButtonLoader"
              @click="proceedAws"
            >Proceed to AMS Filling</md-button>
            <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
          </md-layout>
        </md-layout>
      </md-card-content>
    </md-card>
    <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="note-modal" hide-footer title>
      <div class="d-block text-center">
        <h3>
          {{
          noteModal.creditDebitNoteType == "1" ? "CREDIT NOTE" : "DEBIT NOTE"
          }}
        </h3>
        <br />
        <h4 class="error">
          {{
          noteModal.approvalStatus == "1"
          ? "Approved"
          : noteModal.sentForApproval == "1"
          ? "Sent for approval"
          : ""
          }}
        </h4>
      </div>
      <b-button
        v-if="
          noteModal.uploadCreditDebit != '' && noteModal.approvalStatus == '1'
        "
        @click="PrintNote(noteModal.uploadCreditDebit)"
        size="sm"
        variant="warning"
      >PDF</b-button>

      <b-button @click="addContent" size="sm">
        Add Particulars
        <i class="fa fa-plus-circle ml-1"></i>
      </b-button>

      <b-row>
        <b-col cols="2">
          <md-layout style="width: 400px">
            <label for="blType">To</label>
            <model-list-select
              :list="AgentColoaderList"
              option-value="agentName"
              option-text="agentName"
              v-model="noteModal.AgentColoader"
              placeholder="Select Agent/Client"
            ></model-list-select>
            <span class="error" v-if="!noteModal.AgentColoader">{{errorCDNote.AgentColoader}}</span>
            <!-- <span class="error" v-if="!BLRaised.blStage">{{errorBLRaised.blStage}}</span> -->
          </md-layout>
          <!-- <label>Date</label>
          <date-picker
            :format="selectDateFormat"
            v-model="noteModal.noteDate"
            lang="en"
            id="blDate"
            name="blDate"
          ></date-picker>-->
        </b-col>
      </b-row>
      <div class="mt-4" v-for="(item, index) in noteParticulars" :key="index">
        <b-row>
          <b-col cols="8">
            <label for="jj">Particular</label>
            <b-form-input
              :formatter="capitalizeAll"
              v-model="item.parti"
              placeholder="Enter Particular"
            ></b-form-input>
          </b-col>
          <b-col cols="2">
            <label for="jju">Amount</label>
            <b-form-input
              :formatter="capitalizeAll"
              v-model="item.amt"
              type="number"
              placeholder="Enter Amount"
            ></b-form-input>
          </b-col>
          <b-button
            class="pull-right"
            style="margin-top: 38px"
            v-if="index > 0"
            size="sm"
            @click="removeParti(index)"
          >
            <i class="fa fa-minus-circle" aria-hidden="true"></i>
          </b-button>
        </b-row>
      </div>

      <b-row class="mt-2">
        <b-col>
          <label for="jj">Remarks</label>
          <b-form-textarea :formatter="capitalizeAll" v-model="noteModal.remarks"></b-form-textarea>
        </b-col>
      </b-row>
      <b-button
        class="mt-3"
        variant="success"
        v-if="
          noteParticulars.length > 0 &&
          ShowSendApproval == true &&
          noteModal.approvalStatus != '1'
        "
        block
        @click="submitNote"
      >Send for approval</b-button>
      <b-button class="mt-5" variant="outline-danger" block @click="hideNoteModal">Close</b-button>
    </b-modal>

    <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="pre-alert-modal" hide-footer title>
      <b-row class="mt-2">
        <b-col cols="9">
          <div class="d-block text-center">
            <h3>FCL Export BL Pre Alert</h3>
            <br />
          </div>
        </b-col>
        <b-col cols="3">
          <b-button
            v-if="preAlertData.fclConAlertId != '' && allData[0].billingType!='1'"
            @click="sendMANIFESTATION"
            size="sm"
            variant="warning"
            style="margin-left: 5px"
          >SEND MANIFESTATION DETAILS</b-button>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="4">
          <label for="jj">AGENT REFERENCE ID</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.agent_reference_id"
            placeholder="VESSEL & VOY"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">SHIPPING LINE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shippingLine"
            placeholder="SHIPPING LINE"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">SHIPMENT TYPE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shipmentType"
            placeholder="SHIPMENT TYPE"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">SHIPPER NAME</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.shipper_name"
            placeholder="SHIPPER NAME"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">CONSIGNEE</label>
          <!-- <b-form-input :formatter="capitalizeAll"  placeholder="CONSIGNEE"  ></b-form-input> -->
          <b-form-textarea :formatter="capitalizeAll" v-model="preAlertData.consignee"></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">OVERSEAS AGENT</label>
          <!-- <b-form-input :formatter="capitalizeAll"   placeholder="OVERSEAS AGENT"  ></b-form-input> -->
          <b-form-textarea :formatter="capitalizeAll" v-model="preAlertData.delieveryAgent"></b-form-textarea>
        </b-col>
        <b-col cols="6">
          <label for="jj">LOAD PORT</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.portLoad"
            placeholder="LOAD PORT"
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">PLACE OF DELIVERY</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.placeDilievery"
            placeholder="PLACE OF DELIVERY"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">CONTAINER NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.container_no"
            placeholder="CONTAINER NO."
          ></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="4">
          <label for="jj">HOUSE BL NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.house_bl_no"
            placeholder="HOUSE BL NO."
          ></b-form-input>
        </b-col>
        <b-col cols="4">
          <label for="jj">MASTER BL NO.</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.master_bl_no"
            placeholder="MASTER BL NO."
          ></b-form-input>
        </b-col>
        <b-col cols="4">
          <label for="jj">VESSEL & VOY</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.vesselVoy"
            placeholder="VESSEL & VOY"
          ></b-form-input>
        </b-col>
        
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <label for="jj">ETD / SOB DATE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.etd_date"
            placeholder="ETD / SOB DATE"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="jj">ETA DISCHARGE</label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="preAlertData.eta_date"
            placeholder="ETA DISCHARGE"
          ></b-form-input>
        </b-col>
        <b-col cols="6">
          <label for="deliveryTerms">Delivery Terms(INCOTERMS)<span class="error">*</span></label>
            <model-list-select
              :list="deliveryTermsName"
              v-model="preAlertData.deliverytermmode"
              option-value="deliveryTermsVal"
              option-text="deliveryTermsText"
              placeholder="Select Delivery Terms"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.deliverytermmode}}</span>
        </b-col>
        <b-col cols="6" v-if="preAlertData.deliverytermmode=='ExWorks' || preAlertData.deliverytermmode=='DAP' || preAlertData.deliverytermmode=='DDP' || preAlertData.deliverytermmode=='FCA' || preAlertData.deliverytermmode=='FOB' || preAlertData.deliverytermmode=='CIF' || preAlertData.deliverytermmode=='CFR'">
            <label for="blType">Handling Agent<span class="error">*</span></label>
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllAgentDDList']"
              option-value="value"
              option-text="text"
              v-model="preAlertData.handling_agent"
              placeholder="Select Handling Agent"
              @input="getAgentDeatils(preAlertData.handling_agent,'handling_agent')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.handling_agent}}</span>
        </b-col>
        <b-col cols="6" v-if="preAlertData.deliverytermmode=='ExWorks' || preAlertData.deliverytermmode=='DAP' || preAlertData.deliverytermmode=='DDP' || preAlertData.deliverytermmode=='FCA'">
            <label for="blType">Clearing Agent<span class="error">*</span></label>
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllAgentDDList']"
              option-value="value"
              option-text="text"
              v-model="preAlertData.clearing_agent"
              placeholder="Select Clearing Agent"
              
              @input="getAgentDeatils(preAlertData.clearing_agent,'clearing_agent')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.clearing_agent}}</span>
        </b-col>
        <b-col cols="6" v-if="preAlertData.deliverytermmode=='ExWorks' || preAlertData.deliverytermmode=='DAP' || preAlertData.deliverytermmode=='DDP' || preAlertData.deliverytermmode=='FCA'">
            <label for="blType">Delivery Agent<span class="error">*</span></label>
            <model-list-select
              :list="invCategoryList"
              option-value="payVal"
              option-text="payText"
              v-model="preAlertData.delivery_agent"
              placeholder="Select Delivery Agent"
              
              @input="getAgentDeatils(preAlertData.delivery_agent,'delivery_agent')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.delivery_agent}}</span>
        </b-col>
        <!-- <b-col md="6">
          <label>Agent/Shippine Line<span class="error">*</span></label>
          <b-form-radio-group
            v-model="preAlertData.agent_type"
            :options="invCategoryList"
            class="mb-3"
            value-field="payVal"
            text-field="payText"
            disabled-field="notEnabled"
          ></b-form-radio-group>
        </b-col> -->
        <b-col cols="6" v-if="preAlertData.delivery_agent=='Agent'">
            <label for="blType">Agent<span class="error">*</span></label>
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllAgentDDList']"
              option-value="value"
              option-text="text"
              v-model="preAlertData.agent_type_agent"
              placeholder="Select Agent"
              
              @input="getAgentDeatils(preAlertData.agent_type_agent,'agent_type_agent')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.agent_type_agent}}</span>
        </b-col>
        <b-col cols="6" v-if="preAlertData.delivery_agent=='Shipping Line'">
            <label for="blType">Shipping Line<span class="error">*</span></label>
            <model-list-select
              :list="$store.getters['common/getAllShippingLineList']"
              v-model="preAlertData.agent_type_sline"
              option-value="shippingId"
              option-text="shippingLine"
              placeholder="Select Shipping Line"
              
              @input="getAgentDeatils(preAlertData.agent_type_sline,'agent_type_sline')"
            ></model-list-select>
            <span class="error">{{errorCustomValidation.agent_type_sline}}</span>
        </b-col>
        <b-col cols="6">
          <label for="frghtTermsHbl">Shipping Line Charges<span class="error">*</span></label>
          <model-list-select
            :list="frghtTermsHblListName"
            v-model="preAlertData.sline_charges"
            option-value="frghtTermsHblVal"
            option-text="frghtTermsHblTxt"
            placeholder="Select Shipping Line Charges"
          ></model-list-select>
          <span class="error">{{errorCustomValidation.sline_charges}}</span>
        </b-col>
      </b-row>

      <md-layout gutter class="my-4">
        <md-layout md-flex="5"></md-layout>
        <md-layout md-flex="30">
          <md-input-container>
            <label>Upload Master BL</label>
            <!-- v-model="preAlertData.masterBlUpload" -->
            <md-file
              placeholder="Click to Upload Master BL"
              name="masterUpload"
              id="masterUpload"
              v-model="preAlertData.masterBlUpload"
              @selected="onFileChangeBlDraft('masterBl')"
              multiple
            ></md-file>
          </md-input-container>
          <b
            v-if="preAlertData.masterBlUpload!=''&&preAlertData.masterBlUpload!=undefined&&preAlertData.masterBlUpload!=null"
          >
            <span
              v-for="(item_MB_doc, index_MB_doc) in preAlertData.masterBlUpload.split(',')"
              :key="index_MB_doc"
            >
              <a
                v-if="item_MB_doc !=''"
                href="javascript:void(0)"
                @click="Print(item_MB_doc)"
              >View Document - {{ index_MB_doc + 1 }}</a>
              <br />
            </span>
          </b>
        </md-layout>
        <md-layout md-flex="5"></md-layout>
        <md-layout md-flex="25">
          <md-input-container>
            <label>Upload House BL</label>
            <!-- v-model="preAlertData.houseBlUpload" -->
            <md-file
              placeholder="Click to Upload House Bl"
              name="houseUpload"
              id="houseUpload"
              v-model="preAlertData.houseBlUpload"
              @selected="onFileChangeBlDraft('houseBl')"
              multiple
            ></md-file>
          </md-input-container>
          <b
            v-if="preAlertData.houseBlUpload!=''&&preAlertData.houseBlUpload!=undefined&&preAlertData.houseBlUpload!=null"
          >
            <span
              v-for="(item_HB_doc, index_HB_doc) in preAlertData.houseBlUpload.split(',')"
              :key="index_HB_doc"
            >
              <a
                v-if="item_HB_doc !=''"
                href="javascript:void(0)"
                @click="Print(item_HB_doc)"
              >View Document - {{ index_HB_doc+ 1 }}</a>
              <br />
            </span>
          </b>
        </md-layout>
      </md-layout>

      <b-button
        class="mt-3"
        variant="success"
        block
        :disabled="(preAlertData.condition)"
        @click="submitPreAlert"
      >Send Pre Alert request</b-button>
      <b-button class="mt-5" variant="outline-danger" block @click="hidePreAlert">Close</b-button>
    </b-modal>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="popMailAfter"></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="openPreAlert"
      ref="popBlStageMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendBLApprovalMail"
      ref="popBLMail"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
// import BannerComponent from "../allModuleForm/bannerComponent.vue";
import BannerComponent from "../allModuleForm/trackingBannerComponent.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList"
        })
      );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    if (
      globalPermissionStatus("Sea Freight") ||
      globalPermissionStatus("Overseas Agent Assignments")
    ) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/conBLNonUs");
      this.$store.dispatch(
      "commonDropdownMaster/setAllAgentDDList",
      JSON.stringify({
        itemCode: "getAgentDDList",
        type: "Normal",
      })
    );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      selectAllContainers: false,
      isIndeterminate: false,

      savegenerateblprealertStatus: false,
      BLDetailsList: [],
      selectDateFormat,
      isConsolidation: 1,
      trackingId: "",
      assignmentNo: "",
      allData: [],
      note_id: "",
      originalDone: false,
      blStageListAfterOriginalCreated: [
        {
          blStageVal: "SEAWAY",
          blStageTxt: "SEAWAY"
        }
      ],
      prevBlStage: "",
      AgentColoaderList: [],
      ShowSendApproval: "",
      allModuleId: "",
      containerTypeDetailFactory: [],
      noteContent: "",
      noteAmount: "",
      noteParticulars: [],
      creditDebitNoteData: [],
      noteModal: {
        branchName: "",
        branchList: [],
        creditDebitNoteType: "",
        AgentColoader: "",
        remarks: "",
        noteDate: "",
        note_id: "",
        noteContent: "",
        noteAmount: "",
        ffExportFclId: "",
        allModuleId: "",
        fclBlId: "",
        BLNumber: "",
        uploadCreditDebit: "",
        sentForApproval: "",
        approvalStatus: "",
        masterorLinerBlNo: ""
      },
      docURL: URL_BASE_DOC,
      isLoading: false,
      content: `<h2 class="ql-align-center"><span class="ql-font-serif">sajnsajknsakjnask content loading..</span></h2>`,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      containerNoName: [],
      getCLientData: [],
      nonUsBlTable: [],
      BLRaised: {
        selected_container:"",
        blCreatedDate: "",
        ffExportFclConsoSeries: "",
        conFclBLNonUsId: "",
        fclConsoMultipleClientId: "",
        clientName: "",
        clientAddress: "",
        uploadBLCon: "",

        blStage: "",
        consignor: "",
        consignee: "",
        shippingReferenceNum: "",
        typeMove: "",
        originalBill: "",
        notifyList: [
          {
            inputValue: "",
            text: ""
          },
          {
            inputValue: "",
            text: "Second"
          }
        ],

        preCarriage: "",
        acceptanceDate: "",
        billLading: "",
        modeMean: "",
        routePlace: "",
        vesselVoy: "",
        agent_reference_id:"",
        portLoad: "",
        portDischarge: "",
        placeDilievery: "",
        // containerMarks: "",
        // noPkg: "",
        descriptionGood: "",
        // grossWeight: "",
        // netWeight: "",
        // measurement: "",
        desCharges: "",
        prepaid: "",
        collect: "",
        placeBranch: "",
        delieveryAgent: "",
        total: "",
        portLocationType: "NON_USA",
        ffFclConsoExportId: "",
        ffConExecutionId: "",
        conFclBookingId: "",
        blDate: "",
        isConsolidation: 1,
        allModuleId: "",
        createUpdate: ""
      },

      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth"
      ],

      errorBLRaised: {
        blStage: "",
        consignor: "",
        consignee: "",
        // shippingReferenceNum: "",
        typeMove: "",

        // preCarriage: "",

        billLading: "",
        // vesselVoy: "",
        // agent_reference_id:"",
        portLoad: "",
        portDischarge: "",
        placeDilievery: "",
        // containerMarks: "",
        // noPkg: "",
        descriptionGood: "",
        // grossWeight: "",
        // netWeight: "",
        // measurement: "",
        desCharges: "",
        prepaid: "",
        collect: "",
        placeBranch: "",
        // delieveryAgent: "",
        total: ""
        // bookingNo: "",
        // SCAC: "",
        // exportReference: "",
        // consolidationNO: "",
        // forwardingAgent: "",
        // pointofOrigin: "",
        // placeReceipt: "",
        // loadingPreTerminal: "",
        // reference: ""
      },
      preAlertData: {
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId"),
        vesselVoy: "",
        agent_reference_id:"",
        portLoad: "",
        placeDilievery: "",
        agentId: "",
        consignee: "",
        delieveryAgent: "",
        shipmentType: "fcl",
        etd_date: "",
        eta_date: "",
        house_bl_no: "",
        master_bl_no: "",
        container_no: "",
        shippingLine: "",
        shipper_name: "",
        masterBlUpload: "",
        houseBlUpload: "",
        masterBlUpload_btn: "",
        houseBlUpload_btn: "",
        masterBlUpload_flag: false,
        houseBlUpload_flag: false,
        condition: true,
        deliverytermmode:"",
        handling_agent:"",
        handling_agent_text:"",
        clearing_agent:"",
        clearing_agent_text:"",
        delivery_agent:"",
        delivery_agent_text:"",
        agent_type:"",
        agent_type_agent:"",
        agent_type_agent_text:"",
        agent_type_sline:"",
        agent_type_sline_text:"",
        sline_charges:"",
      },
      frghtTermsHblListName: [
        {
          frghtTermsHblVal: "Prepaid",
          frghtTermsHblTxt: "Prepaid",
        },
        {
          frghtTermsHblVal: "Collect",
          frghtTermsHblTxt: "Collect",
        },
      ],
      invCategoryList: [
        {
          payVal: "Agent",
          payText: "Agent",
          notEnabled: false,
        },
        {
          payVal: "Shipping Line",
          payText: "Shipping Line",
          notEnabled: false,
        },
      ],
      errorCustomValidation: {
        deliverytermmode: "",
        handling_agent: "",
        clearing_agent: "",
        delivery_agent: "",
        agent_type_agent: "",
        agent_type_sline: "",
        sline_charges:"",
      },
      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "ExWorks",
        },
        {
          deliveryTermsVal: "FOB",
          deliveryTermsText: "FOB",
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF",
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP",
        },
        {
          deliveryTermsVal: "DDU",
          deliveryTermsText: "DDU",
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP",
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR",
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA",
        },
      ],
      arrayErrorBLRaised: [
        {
          blStage: "Please Select BL Stage",
          consignor: "Please Enter Consignor",
          consignee: "Please Enter Consignee",
          // shippingReferenceNum: "Please Enter Shipping Reference",
          typeMove: "Please Enter Type Move",

          // preCarriage: "Please Enter Pre Carriage",

          billLading: "Please Enter Bill Lading No",

          // vesselVoy: "Please Enter Vessel Voy",
          portLoad: "Please Enter Port Load",
          portDischarge: "Please Enter Port Discharge",
          placeDilievery: "Please Enter Place Delievery",
          // containerMarks: "Please Enter Container Marks",
          // noPkg: "Please Enter No of Package",
          descriptionGood: "Please Enter Description Good",
          // grossWeight: "Please Enter Gross Weight",
          // netWeight: "Please Enter Net Weight",
          // measurement: "Please Enter Measurement",
          desCharges: "Please Enter Description Charges",
          prepaid: "Please Enter Prepaid",
          collect: "Please Enter Collect",
          placeBranch: "Please Enter Branch",
          // delieveryAgent: "Please Select Delievery Agent",
          total: "Please Enter Total",
          bookingNo: "Enter Booking No",
          // SCAC: "Enter SCAC",
          // exportReference: "Enter Export Reference ",
          // consolidationNO: "Enter Consolidation Number",
          // forwardingAgent: "Select Agent",
          // pointofOrigin: "Enter Point of Origin",
          placeReceipt: "Enter Place of Receipt"
          // loadingPreTerminal: "Enter Loading Terminal",
          // reference: "Enter References"
        }
      ],
      errorCDNote: {
        AgentColoader: ""
      },
      arrayErrorCDNote: [
        {
          AgentColoader: "Please Select To"
        }
      ],
      notifyListArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seven",
        "Eight"
      ],

      blStageList: [
        {
          blStageVal: "DRAFT",
          blStageTxt: "DRAFT"
        },
        {
          blStageVal: "ORIGINAL",
          blStageTxt: "ORIGINAL"
        },

        {
          blStageVal: "NON-NEGOTIABLE",
          blStageTxt: "Non/­Negotiable"
        },
        {
          blStageVal: "SEAWAY",
          blStageTxt: "SEAWAY"
        }
      ],

      PlaceListNew: [],
      PlaceList: [
        {
          PlaceVal: "Delhi",
          PlaceTxt: "Delhi"
        },
        {
          PlaceVal: "Jaipur",
          PlaceTxt: "Jaipur"
        }
      ],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      AgentList: [],
      validate: true
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  watch: {
    BLRaised: {
      handler: function(newVal, oldVal) {
        if (this.BLRaised.notifyList) {
          for (let i = 0; i < this.BLRaised.notifyList.length; i++) {
            let noti = this.BLRaised.notifyList[i].inputValue;
            let result3 = noti.replaceAll("&nbsp;", " ");
            this.BLRaised.notifyList[i].inputValue = result3;
          }
          console.log(this.BLRaised.notifyList, "j");
        }

        if (this.BLRaised.consignee) {
          let consine = this.BLRaised.consignee;

          let result1 = consine.replaceAll("&nbsp;", " ");
          this.BLRaised.consignee = result1;
        }
        if (this.BLRaised.consignor) {
          let consinr = this.BLRaised.consignor;
          let result2 = consinr.replaceAll("&nbsp;", " ");
          this.BLRaised.consignor = result2;
        }
        if (this.BLRaised.descriptionGood) {
          let blRaised = this.BLRaised.descriptionGood;
          let result = blRaised.replaceAll("<p><br></p>", "");
          let result6 = blRaised.replaceAll("&nbsp;", " ");
          // console.log(result,"test")
          this.BLRaised.descriptionGood = result6;
        }
        // this.BLRaised.ffExportFclConsoSeries
        this.BLRaised.fclBlId = this.BLRaised.conFclBLNonUsId;
        console.log("this.BLRaised=>", this.BLRaised);
        if (this.BLRaised.placeBranch != "") {
          this.getBranchName();
        }
        if (this.BLRaised.delieveryAgent != "") {
          this.getAgentName();
        }
      },
      deep: true
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor,
    BannerComponent,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
  },

  computed: {
    containerNoList() {
      return this.containerNoName;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    commodityList() {
      return this.getCommodityData;
    },
    clientList() {
      return this.getCLientData;
    },

     // Container selection computed properties
     selectedContainersCount() {
      return this.getSelectedContainers().length;
    },
    selectableContainersCount() {
      return this.containerDetail.filter(item => item.containerWithSplit != 1).length;
    },
    hasSelectedContainers() {
      return this.selectedContainersCount > 0;
    },
    allContainersSelected() {
      return this.selectedContainersCount === this.selectableContainersCount && this.selectableContainersCount > 0;
    }
  },

  methods: {
      
    // Container selection methods
    toggleSelectAll() {
      this.containerDetail.forEach(item => {
        if (item.containerWithSplit != 1) {
          item.selected = this.selectAllContainers;
        }
      });
      this.updateSelectAll();
    },
    
    updateSelectAll() {
      const selectableContainers = this.containerDetail.filter(item => item.containerWithSplit != 1);
      const selectedContainers = selectableContainers.filter(item => item.selected);
      
      if (selectedContainers.length === 0) {
        this.selectAllContainers = false;
        this.isIndeterminate = false;
      } else if (selectedContainers.length === selectableContainers.length) {
        this.selectAllContainers = true;
        this.isIndeterminate = false;
      } else {
        this.selectAllContainers = false;
        this.isIndeterminate = true;
      }
    },
    
    getSelectedContainers() {
      return this.containerDetail.filter(item => item.selected);
    },
    
    getSelectedContainersMinimal() {
      return this.containerDetail
        .filter(item => item.selected)
        .map(item => ({
          uniqueContainerId: item.ffExecutionContainerId,
          containerNo: item.containerNo
        }));
    },
    
    getSelectedContainerIds() {
      return this.getSelectedContainers().map(item => item.ffExecutionContainerId);
    },
    
    getSelectedContainerNumbers() {
      return this.getSelectedContainers().map(item => item.containerNo);
    },

    
    // Method to select a single container by container number
    selectContainerByNumber(containerNumber) {
      const container = this.containerDetail.find(item => item.containerNo === containerNumber);
      if (container && container.containerWithSplit != 1) {
        container.selected = true;
        this.updateSelectAll();
      }
    },
    
    // Method to deselect a single container by container number
    deselectContainerByNumber(containerNumber) {
      const container = this.containerDetail.find(item => item.containerNo === containerNumber);
      if (container) {
        container.selected = false;
        this.updateSelectAll();
      }
    },
    
    // Method to get containers for operations (uses selected containers if any, otherwise all containers)
    getContainersForOperation() {
      const selectedContainers = this.getSelectedContainers();
      return selectedContainers.length > 0 ? selectedContainers : this.containerDetail;
    },
    
    // Method to auto-select containers from saved data
    autoSelectContainersFromData(selectedContainerData) {
      console.log("priyanshu Singh containerIds1=>", selectedContainerData);
      console.log("priyanshu Singh containerDetail1=>", this.containerDetail);
      if (!selectedContainerData || !this.containerDetail.length) {
        return;
      }
     
      
      try {
        // Clear all current selections first
        this.containerDetail.forEach(container => {
          container.selected = false;
        });
        
        // Handle comma-separated string format (e.g., "167477, 167478, ")
        if (typeof selectedContainerData === 'string') {
          // Split by comma and clean up whitespace and empty values
          const containerIds = selectedContainerData
            .split(',')
            .map(id => id.trim())
            .filter(id => id !== '' && id !== null && id !== undefined);
            console.log("priyanshu Singh containerIds=>", containerIds);
            console.log("priyanshu Singh containerDetail=>", this.containerDetail);
          // Select containers based on uniqueContainerId
          containerIds.forEach(containerId => {
            const container = this.containerDetail.find(item => 
              item.uniqueContainerId == containerId
            );
            
            if (container && container.containerWithSplit != 1) {
              container.selected = true;
            }
          });
        }
        
        // Update the select all state
        this.updateSelectAll();
        
        console.log('Auto-selected containers from saved data:', selectedContainerData);
      } catch (error) {
        console.error('Error auto-selecting containers:', error);
      }
    },
    
    // Method to validate container selection
    validateContainerSelection() {
      const selectedContainers = this.getSelectedContainers();
      if (selectedContainers.length === 0) {
        this.alert.content = "Please select at least one container to proceed";
        this.$refs["addPop"].open();
        return false;
      }
      return true;
    },

    getAgentDeatils(item,key){
      let agentFilter = [];
      if(key=='handling_agent' || key=='clearing_agent'  || key=='agent_type_agent'){
        agentFilter = this.$store.getters['commonDropdownMaster/getAllAgentDDList'].filter((x) => {
                          return x.value == item;
                      });
      }
      if(key=='agent_type_sline'){
        agentFilter = this.$store.getters['common/getAllShippingLineList'].filter((x) => {
                          return x.shippingId == item;
                      });
      }
      console.log("agentFilter=>",agentFilter)
      
      if(key=='handling_agent'){
        this.preAlertData.handling_agent_text=agentFilter[0].text;
      }else if(key=='clearing_agent'){
        this.preAlertData.clearing_agent_text=agentFilter[0].text;
      }else if(key=='agent_type_agent'){
        this.preAlertData.agent_type_agent_text=agentFilter[0].text;
      }else if(key=='agent_type_sline'){
        this.preAlertData.agent_type_sline_text=agentFilter[0].shippingLine;
      }
    },
    checBlstage(item) {
      if (item == "DRAFT") {
        this.savegenerateblprealertStatus = false;
      } else if (this.preAlertData.fclConAlertId != "" && item != "DRAFT") {
        this.savegenerateblprealertStatus = false;
      } else {
        this.savegenerateblprealertStatus = true;
      }
      //  alert(item);
      //  alert(this.savegenerateblprealertStatus);
      // alert(this.prevBlStage);
      // alert(item);
      if (
        this.prevBlStage == "DRAFT" &&
        this.prevBlStage != item &&
        this.savegenerateblprealertStatus == true
      ) {
        // alert("Hello");
        this.openPopBLStage();
      }
    },
    onFileChangeBlDraft(ID) {
      this.isLoading = true;
      this.preAlertData.condition = true;
      let files = event.target.files || event.dataTransfer.files;
      console.log(files);
      let exportfclId = this.$sessionsStorage.get("editffFclConsoExportId");
      let allModuleId = this.allModuleId;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "masterBl") {
          this.preAlertData.masterBlUpload_flag = true;
          formData.append(
            "staticFileName",
            "Sea_Export_MasterBL_" + allModuleId
          );
        } else if (ID == "houseBl") {
          this.preAlertData.houseBlUpload_flag = true;
          formData.append(
            "staticFileName",
            "Sea_Export_HouseBL_" + allModuleId
          );
        }

        formData.append(
          "upload_dir_folderName",
          // "FF_Sea_Export_Sline_Payments_Uploads"
          this.BLRaised.ffExportFclConsoSeries.replaceAll("/", "_")
        );
      }

      console.log("Upload => ", formData);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + exportfclId
        }
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then(result => {
          if (ID == "masterBl") {
            this.preAlertData["masterBlUpload"] = "";
            this.preAlertData["masterBlUpload"] = result.data;
            // this.preAlertData.masterBlUpload = result.data;
            this.preAlertData.masterBlUpload_btn = result.data;
          } else {
            // this.preAlertData.houseBlUpload = result.data;
            this.preAlertData["houseBlUpload"] = "";
            this.preAlertData["houseBlUpload"] = result.data;
            this.preAlertData.houseBlUpload_btn = result.data;
          }
          this.preAlertData.condition =
            this.preAlertData.masterBlUpload_flag &&
            this.preAlertData.houseBlUpload_flag
              ? this.preAlertData.masterBlUpload_btn &&
                this.preAlertData.houseBlUpload_btn
                ? false
                : true
              : false;
          this.isLoading = false;
        })
        .catch(err => {
          throw err;
        });
    },

    getBranchName() {
      let arry = this.pridelBranchLocation.filter(x => {
        return x.pickupId == this.BLRaised.placeBranch;
      });
      if (arry.length > 0) {
        this.BLRaised.branchName = arry[0].pickupLocation;
      }
    },

    openPreAlert() {
      this.isLoading = true;
      this.preAlertData.handling_agent =this.allData[0].delieveryAgent;
      this.preAlertData.clearing_agent =this.allData[0].delieveryAgent;
      this.preAlertData.agent_type_agent =this.allData[0].delieveryAgent;
      this.preAlertData.agent_type_sline =this.allData[0].shippingId;
      if(this.allData[0].delieveryAgent){
        let agentFilter = this.$store.getters['commonDropdownMaster/getAllAgentDDList'].filter((x) => {
                          return x.value == this.allData[0].delieveryAgent;
                      });
                      
        if(agentFilter.length>0){
          this.preAlertData.handling_agent_text =agentFilter[0].text;
          this.preAlertData.clearing_agent_text =agentFilter[0].text;
          this.preAlertData.agent_type_agent_text =agentFilter[0].text;
        }
      }
      if(this.allData[0].shippingId){

        let agentFilter = this.$store.getters['common/getAllShippingLineList'].filter((x) => {
                          return x.shippingId == this.allData[0].shippingId;
                      });
                      
          this.preAlertData.agent_type_sline_text =agentFilter[0].shippingLine;
      }
      let containerNoArryNote = [];
      this.containerDetail.map(x => {
        containerNoArryNote.push(x.fclConcontainerNo);
      });
      if (this.allData[0].prealertDetails) {
        this.preAlertData.masterBlUpload = this.allData[0].prealertDetails.masterBlUpload;
        this.preAlertData.houseBlUpload = this.allData[0].prealertDetails.houseBlUpload;

        this.preAlertData.deliverytermmode = this.allData[0].prealertDetails.deliverytermmode;
        this.preAlertData.handling_agent = this.allData[0].prealertDetails.handling_agent;
        this.preAlertData.handling_agent_text = this.allData[0].prealertDetails.handling_agent_text;
        this.preAlertData.clearing_agent = this.allData[0].prealertDetails.clearing_agent;
        this.preAlertData.clearing_agent_text = this.allData[0].prealertDetails.clearing_agent_text;
        this.preAlertData.delivery_agent = this.allData[0].prealertDetails.delivery_agent;
        this.preAlertData.delivery_agent_text = this.allData[0].prealertDetails.delivery_agent_text;
        this.preAlertData.agent_type = this.allData[0].prealertDetails.agent_type;
        this.preAlertData.agent_type_agent = this.allData[0].prealertDetails.agent_type_agent;
        this.preAlertData.agent_type_agent_text = this.allData[0].prealertDetails.agent_type_agent_text;
        this.preAlertData.agent_type_sline = this.allData[0].prealertDetails.agent_type_sline;
        this.preAlertData.agent_type_sline_text = this.allData[0].prealertDetails.agent_type_sline_text;
        this.preAlertData.etd_date = this.allData[0].prealertDetails.etd_date;
        this.preAlertData.eta_date = this.allData[0].prealertDetails.eta_date;
        this.preAlertData.sline_charges = this.allData[0].prealertDetails.sline_charges;
      }
      console.log("prealertDetails=>", this.prealertDetails);

      console.log("Container No => ", this.containerDetail);
      console.log("this.allData[0]=>", this.nonUsBlTable);
      console.log("this.AgentColoaderList=>", this.AgentColoaderList);

      let delieveryAgent = "";
      let arrayAgentFilter = this.AgentColoaderList.filter(x => {
        if (x.agntColoaderId == this.nonUsBlTable[0].delieveryAgent) {
          return (delieveryAgent = x.agentName);
        }
      });
      if (arrayAgentFilter.length > 0) {
        this.preAlertData["overseas_agent"] = arrayAgentFilter[0].agentName;
        this.preAlertData.delieveryAgent = arrayAgentFilter[0].agentName;
        this.BLRaised.delieveryAgent = arrayAgentFilter[0].agentName;
      }
      // alert(this.preAlertData.delieveryAgent);
      // alert(delieveryAgent);
      // let AGent_Name = this.AgentColoaderList.forEach((ag_val,ag_key)=>{
      //   if(ag_val.agntColoaderId ==this.nonUsBlTable[0].delieveryAgent){
      //     return ag_val.agentName;
      //   }

      // })
      console.log("this.AGent_Name=>", this.allData);

        if(this.allData.length>0){
          this.$store.getters['common/getAllShippingLineList'].forEach((ele,ind)=>{
              if(ele.shippingId == this.allData[0].shippingId){
                this.BLRaised.shippingId = ele.shippingId;
                this.BLRaised.shippingLine = ele.shippingLine;
              }
          })
        }
      

      this.preAlertData["container_no"] = containerNoArryNote.toString();
      this.preAlertData["allModuleId"] = this.allModuleId;
      this.preAlertData["shippingId"] = this.BLRaised.shippingId || "";
      this.preAlertData["shippingLine"] = this.BLRaised.shippingLine || "";
      //  this.preAlertData["delieveryAgent"] = this.BLRaised.agentName;
      //  this.preAlertData["agentAddress"] = this.BLRaised.agentAddress;
      //  this.preAlertData["vesselVoy"] = this.BLRaised.vesselVoy;
      //  this.preAlertData["agent_reference_id"] = this.BLRaised.agent_reference_id;
      //  this.preAlertData["shipper_name"] = this.BLRaised.clientName || "";
      //  this.preAlertData["consignee"] = this.BLRaised.consignee;
      this.preAlertData["fclBlId"] = this.BLRaised.fclBlId;
      this.preAlertData["branchName"] = this.BLRaised.branchName;
      this.preAlertData["placeDilievery"] = this.BLRaised.placeDilievery;
      this.preAlertData["portLoad"] = this.BLRaised.portLoad;
      this.preAlertData["assignmentNo"] = this.BLRaised.ffExportFclConsoSeries;
      this.preAlertData[
        "ffExportFclSeries"
      ] = this.BLRaised.ffExportFclConsoSeries.replaceAll("/", "_");

      this.preAlertData["mailPreAlert"] = "1";

      if (
        this.BLRaised.delieveryAgent != "" &&
        this.BLRaised.delieveryAgent != undefined
      ) {
        this.preAlertData["overseas_agent"] =
          this.BLRaised.delieveryAgent || "";
      }

      // alert(this.BLRaised.delieveryAgent);
      // alert(this.BLRaised.master_bl_no);
      if (
        this.BLRaised.master_bl_no != "" &&
        this.BLRaised.master_bl_no != undefined
      ) {
        this.preAlertData["master_bl_no"] = this.BLRaised.master_bl_no || "";
      } else {
        this.preAlertData["master_bl_no"] = this.noteModal.linerBLNumber || "";
      }
      if (
        this.BLRaised.house_bl_no != "" &&
        this.BLRaised.house_bl_no != undefined
      ) {
        this.preAlertData["house_bl_no"] = this.BLRaised.house_bl_no || "";
      } else {
        this.preAlertData["house_bl_no"] = this.BLRaised.billLading || "";
      }
      console.log("PrealertDeatils=>", this.preAlertData);
      //  this.preAlertData["master_bl_no"] = this.noteModal.linerBLNumber || "";
      //  this.preAlertData["house_bl_no"] = this.BLRaised.billLading || "";

      if (this.trackingId != "") {
        let payload = {
          subscriptionId: this.trackingId
        };

        // console.log(this.$sessionsStorage.get("loginId"))

        console.log("Test => ", payload);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Tracking/globalTracking.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            this.isLoading = false;
            const { statusText, status, data } = result;

            // alert(statusText+" : "+status+" : "+data)
            if (status == 200 && data) {
              //alert(data);

              console.log("Result => ", JSON.parse(data.data));

              data.data = JSON.parse(data.data);

              // this.shippmentDetails.push(data.data);

              if (data.data.containershipments.length > 0) {
                this.preAlertData["vesselVoy"] = data.data
                  .containershipments[0]["current_vessel"]
                  ? data.data.containershipments[0]["current_vessel"]["name"]
                  : "";
                this.preAlertData["etd_date"] =
                  data.data.containershipments[0]["pol_vsldeparture_actual"] ||
                  data.data.containershipments[0][
                    "pol_vsldeparture_planned_last"
                  ];
                this.preAlertData["eta_date"] =
                  data.data.containershipments[0]["pod_vslarrival_actual"] ||
                  data.data.containershipments[0][
                    "pod_vslarrival_planned_last"
                  ];
              }
            }
          })
          .catch(error => {
            this.isLoading = false;
            console.log("Err => ", error);
          });
      }

      this.isLoading = false;

      this.$refs["pre-alert-modal"].show();
    },

    hidePreAlert() {
      this.$refs["pre-alert-modal"].hide();
      if (this.savegenerateblprealertStatus == true) {
        this.openPopensureprealert();
      }
    },
    openPopensureprealert() {
      this.alert.content = "Please Ensure Pre-ALert is Send";
      this.$refs["popMailAfter"].open();
      // this.$refs["popMail"].open();
    },
    sendMANIFESTATION() {
      this.$sessionsStorage.set("sendManifest_ffFclConsoallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffType", "");
      this.$sessionsStorage.set("sendManifest_ffType", "FF Con Export");
      this.$sessionsStorage.set(
        "sendManifest_ffFclConsoallModuleId",
        this.allModuleId
      );
      this.$sessionsStorage.set(
        "sendManifest_ffFclConsoExportId",
        this.preAlertData.ffFclConsoExportId
      );
      this.$router.push({
        path: "/ffExportCon/ffconsendManifestation"
      });
    },
    submitPreAlert() {
      Object.keys(this.errorCustomValidation).map((x, index) => {
        this.errorCustomValidation[x] = "";
      });
      if(!this.preAlertData.deliverytermmode){
        this.errorCustomValidation.deliverytermmode = "Please Select Delivery Terms(INCOTERMS)";
        return false;
      }
      if(!this.preAlertData.sline_charges){
        this.errorCustomValidation.sline_charges = "Please Select Shipping Line Charges";
        return false;
      }
      if(this.preAlertData.deliverytermmode=='ExWorks' || this.preAlertData.deliverytermmode=='DAP' || this.preAlertData.deliverytermmode=='DDP' || this.preAlertData.deliverytermmode=='FCA' || this.preAlertData.deliverytermmode=='FOB' || this.preAlertData.deliverytermmode=='CIF' || this.preAlertData.deliverytermmode=='CFR'){
        if(!this.preAlertData.handling_agent){
          this.errorCustomValidation.handling_agent = "Please Select Handling Agent";
          return false;
        }
      }
      if(this.preAlertData.deliverytermmode=='ExWorks' || this.preAlertData.deliverytermmode=='DAP' || this.preAlertData.deliverytermmode=='DDP' || this.preAlertData.deliverytermmode=='FCA'){
        if(!this.preAlertData.clearing_agent){
          this.errorCustomValidation.clearing_agent = "Please Select Clearing Agent";
          return false;
        }
      }
      if(this.preAlertData.deliverytermmode=='ExWorks' || this.preAlertData.deliverytermmode=='DAP' || this.preAlertData.deliverytermmode=='DDP' || this.preAlertData.deliverytermmode=='FCA'){
        if(!this.preAlertData.delivery_agent){
          this.errorCustomValidation.delivery_agent = "Please Select Delivery Agent";
          return false;
        }
      }
      if(this.preAlertData.deliverytermmode=='ExWorks' || this.preAlertData.deliverytermmode=='DAP' || this.preAlertData.deliverytermmode=='DDP' || this.preAlertData.deliverytermmode=='FCA'){
        if(this.preAlertData.delivery_agent=='Agent' && !this.preAlertData.agent_type_agent){
          this.errorCustomValidation.agent_type_agent = "Please Select Agent";
          return false;
        }
        if(this.preAlertData.delivery_agent=='Shipping Line' && !this.preAlertData.agent_type_sline){
          this.errorCustomValidation.agent_type_sline = "Please Select Shipping Line";
          return false;
        }
      }
      this.isLoading = true;
      this.preAlertData.agentId = this.nonUsBlTable[0].delieveryAgent;

      let options = {
        method: "POST",
        url: `${URL_BASE}/sendPreAlertMailFclConBL_test_VP.php`,
        // url: `${URL_BASE}/sendPreAlertMailFclConBL_test.php`,
        data: JSON.stringify(this.preAlertData),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          this.isLoading = false;
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Inserted Successfully") {
              this.alert.content = "Request has been sent";
            } else {
              this.alert.content = "Request has been sent";
            }
            this.savegenerateblprealertStatus = false;
            this.$refs["pre-alert-modal"].hide();
            this.$refs["addPop"].open();
          }
        })
        .catch(error => {
          this.isLoading = false;
        });

      this.isLoading = false;
    },
    openPopBLMail() {
      this.alert.content = "Send Edit BL Request";
      this.$refs["popBLMail"].open();
    },
    sendBLApprovalMail(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let containerNoArry = [];
        this.containerTypeDetailFactory.map(x => {
          containerNoArry.push(x.containerNo);
        });

        let newData = {
          mailBLApproval: "CONBLApprovalMail",
          BLNO: this.BLRaised.fclBlId,
          assignmentNo: this.assignmentNo,
          allModuleId: this.allModuleId
        };

        console.log("newData=>", newData);
        // return false;
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/sendConBLApproval.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };

          axios(options)
            .then(result => {
              const { statusText, status, data } = result;
              console.log(data);
              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              // this.savegenerateblprealertStatus=false;
              this.isLoading = false;
            })
            .catch(error => {});
        }
      }
    },
    openPopBLStage() {
      this.alert.content =
        "Please send Pre-Alert ...? then change Bl stage from Draft ";
      this.$refs["popBlStageMail"].open();
    },

    PrintNote(item) {
      if(!item) return;
      let key =
        "ASSIGNMENT_UPLOADS/" +
        this.assignmentNo.replaceAll("/", "_") +
        "/" +
        item;
      this.openSignedDocument(key);
    },
    removeParti(index) {
      this.noteParticulars.splice(index, 1);
    },

    openNoteModal(id) {
      this.isLoading = true;
      this.getNoteData(id);
      setTimeout(() => {
        this.noteModal.creditDebitNoteType = id;
        if (this.noteContent) {
          let dummyCont = this.noteContent.split(",");
          let dummyAmt = this.noteAmount.split(",");

          for (let i = 0; i < dummyCont.length; i++) {
            let obj = {
              parti: dummyCont[i],
              amt: dummyAmt[i]
            };

            this.noteParticulars.push(obj);
          }
        }
        // if(arrayNote[0].sentForApproval=='0'){
        // this.ShowSendApproval=true
        // }else{
        // this.ShowSendApproval=false
        // }
        // }else{
        // this.ShowSendApproval=true
        // }
        // // this.noteModal.note_id=this.creditDebitNoteData[0].note_id
        // // this.noteModal.creditDebitNoteType=this.creditDebitNoteData[0].creditDebitNoteType
        // // this.noteModal.note=this.creditDebitNoteData[0].note_id
        // }else{
        // this.ShowSendApproval=true
        // }
        this.isLoading = false;
        this.ShowSendApproval = true;
        this.$refs["note-modal"].show();
        this.getData();
      }, 2000);
    },
    hideNoteModal() {
      Object.keys(this.noteModal).map((x, index) => {
        this.noteModal[x] = "";
      });
      this.noteModal.approvalStatus = "";
      this.noteModal.sentForApproval = "";
      this.noteContent = "";
      this.noteAmount = "";
      this.note_id = "";
      this.noteModal.remarks = "";
      this.noteParticulars = [];
      this.$refs["note-modal"].hide();
      this.isLoading = false;
    },
    addContent() {
      let obj = {
        parti: "",
        amt: ""
      };

      this.noteParticulars.push(obj);
      console.log(this.noteParticulars);
    },

    validateCDNote() {
      let validate_new = true;
      Object.keys(this.errorCDNote).map((x, index) => {
        if (this.noteModal[x] == "") {
          this.errorCDNote[x] = this.arrayErrorCDNote[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    submitNote() {
      this.validateCDNote();
      if (this.validate == false) return false;
      this.isLoading = true;
      this.ShowSendApproval = false;
      if (this.noteParticulars.length <= 0) {
        this.alert.content = "Please add particulars";
        this.$refs["addPop"].open();
        return false;
      }

      let noteParti = [];
      let noteAmt = [];

      for (let i = 0; i < this.noteParticulars.length; i++) {
        noteParti.push(this.noteParticulars[i].parti);
        noteAmt.push(
          this.noteParticulars[i].amt ? this.noteParticulars[i].amt : 0
        );
      }
      this.noteModal.noteContent = noteParti.toString();
      this.noteModal.noteAmount = noteAmt.toString();
      let containerNoArryNote = [];
      this.containerTypeDetailFactory.map(x => {
        containerNoArryNote.push(x.containerNo);
      });

      this.noteModal["containerNoArryNote"] = containerNoArryNote.toString();
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = this.allModuleId;
      this.noteModal["agentName"] = this.BLRaised.agentName;
      this.noteModal["agentAddress"] = this.BLRaised.agentAddress;
      this.noteModal["vesselVoy"] = this.BLRaised.vesselVoy;
      this.noteModal["agent_reference_id"] = this.BLRaised.agent_reference_id;
      this.noteModal["shipper"] = this.BLRaised.clientName;
      this.noteModal["consignee"] = this.BLRaised.consignee;
      this.noteModal["fclBlId"] = this.noteModal.fclBlId;
      //  this.noteModal["branchName"] = this.PlaceListNew;
      this.noteModal["FinalPlace"] = this.BLRaised.placeDilievery;
      this.noteModal["masterorLinerBlNo"] = this.noteModal.linerBLNumber;
      this.noteModal["BLNumber"] =
        this.BLRaised.billLading + this.noteModal.fclBlId;
      this.noteModal["salesSeries"] = this.BLRaised.ffExportFclConsoSeries;
      this.noteModal[
        "salesSeriesUpload"
      ] = this.BLRaised.ffExportFclConsoSeries.replaceAll("/", "_");

      this.noteModal["ffExportFclId"] = this.$sessionsStorage.get(
        "editExportFCLId"
      );
      if (this.validate != false) {
        console.log(
          this.noteModal.allModuleId,
          this.allModuleId,
          "this.BLRaised.placeBranch",
          this.$sessionsStorage.get("editffFclConsoExportId")
        );
        let obj = {
          noteContent: noteParti.toString(),
          noteAmount: noteAmt.toString(),
          allModuleId: this.noteModal.allModuleId,
          containerNoArryNote: containerNoArryNote.toString(),
          noteParticulars: this.noteParticulars,
          agentName: this.BLRaised.agentName,
          agentAddress: this.BLRaised.agentAddress,
          vesselVoy: this.BLRaised.vesselVoy,
          agent_reference_id: this.BLRaised.agent_reference_id,
          shipper: this.noteModal.clientName,
          consignee: this.BLRaised.consignee,
          fclBlId: 0,
          branchName: this.BLRaised.placeBranch,
          FinalPlace: this.BLRaised.placeDilievery,
          masterorLinerBlNo: this.noteModal.linerBLNumber,
          BLNumber: 0,
          salesSeries: this.BLRaised.ffExportFclConsoSeries,
          salesSeriesUpload: this.BLRaised.ffExportFclConsoSeries.replaceAll(
            "/",
            "_"
          ),
          ffExportFclId: this.$sessionsStorage.get("editffFclConsoExportId"),
          remarks: this.noteModal.remarks,
          noteDate: this.noteModal.noteDate,
          note_id: this.note_id,
          page: "consolidation",
          creditDebitNoteType: this.noteModal.creditDebitNoteType,
          containerNoArryNote: this.containerDetail[0].fclConcontainerNo
            ? this.containerDetail[0].fclConcontainerNo
            : "",
          AgentColoader: this.noteModal.AgentColoader
        };
        console.log(obj);
        console.log(this.BLRaised);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addCreditDebitNoteNew.php`,
          data: JSON.stringify(obj),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            console.log(result);
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.noteModal.approvalStatus = "";
              this.noteModal.sentForApproval = "";
              this.noteContent = "";
              this.noteAmount = "";
              this.note_id = "";
              this.noteModal.remarks = "";
              this.noteModal.AgentColoader = "";

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }

              Object.keys(this.noteModal).map(x => {
                this.noteModal[x] = "";
              });
              this.noteParticulars = [];

              this.$refs["note-modal"].hide();
              this.$refs["addPop"].open();
              // this.getData()
              this.isLoading = false;
            }
          })
          .catch(error => {
            console.log(`erroe`, error);
          });
      }
    },
    getBranchName() {
      let arry = this.pridelBranchLocation.filter(x => {
        return x.pickupId == this.BLRaised.placeBranch;
      });
      if (arry.length > 0) {
        this.BLRaised.branchName = arry[0].pickupLocation;
      }
    },

    getAgentName() {
      let arry1 = this.AgentList.filter(x => {
        return x.agntColoaderId == this.BLRaised.delieveryAgent;
      });
      if (arry1.length > 0) {
        console.log(arry1);
        this.BLRaised.agentName = arry1[0].agentName;
        this.BLRaised.agentAddress = arry1[0].address;
        this.BLRaised.agentEmail = arry1[0].emailId;
        this.BLRaised.agentContact = arry1[0].contactNumber;
      }
    },

    proceedToTally() {
      console.log(this.selectedConFclBLNonUsId);
      this.$router.push({
        name: "Sail and FPOD Con Detail",
        params: {
          conFclBLNonUsId: this.selectedConFclBLNonUsId
        },
        query: {
          allModuleId: this.allModuleId,
          ffExportFclConsoSeries: this.ffExportFclConsoSeries
        }
      });
    },
    proceedToTallyByClient(conFclBLNonUsId, InvTallyId, clientName) {
      this.$router.push({
        name: "Sail and FPOD Con Detail",
        params: {
          conFclBLNonUsId: conFclBLNonUsId
        },
        query: {
          allModuleId: this.allModuleId,
          ffExportFclConsoSeries: this.ffExportFclConsoSeries,
          InvTallyId: InvTallyId || "",
          clientName: clientName
        }
      });
    },
    downloadWord(id) {
      window.location = `${URL_BASE}/Api_FFSeaExport/wordBLConNonUs.php?id=${id}`;
      // window.location =
      //   "http://164.52.196.219/pridelApiNew/Freight/wordBLConNonUs.php?id=" +
      //   id;
    },
    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.BLRaised.notifyList.length]
      };
      this.BLRaised.notifyList.push(obj);
    },
    removeNotify(index) {
      this.BLRaised.notifyList.splice(index, 1);
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    viewEditBLNonUs(item) {
      console.log("Priyanshu=>", item);
      this.BLRaised.fclBlId = item.conFclBLNonUsId;
      this.BLRaised.ffExportFclConsoSeries = this.assignmentNo;
      this.BLRaised.allModuleId = this.allModuleId;

      // alert(item.UpdatedDate? item.UpdatedDate : item.CreatedDate)

      // alert(this.BLRaised.fclBlId);
      // alert(item.blStage);
      if (item.blStage != "" && item.blStage != undefined) {
        if (item.loginTime) {
          this.BLRaised.blCreatedDate = item.loginTime.split(" ")[0];
        }
        this.BLDetailsList = item;
        console.log("this.BLDetailsList=>", this.BLDetailsList);
        if (
          this.BLDetailsList.conFclBLNonUsId != "" &&
          this.BLDetailsList.conFclBLNonUsId != undefined &&
          (this.BLDetailsList.blStage == "ORIGINAL" ||
            this.BLDetailsList.blStage == "SEAWAY")
        ) {
          this.originalDone = true;
          this.BLRaised.blStage = "";
          if (this.BLDetailsList.mail_approved_status == "1") {
            this.originalDone = false;
          }
        }
        console.log("this.BLDetailsList=>", this.BLDetailsList);
        if (
          this.BLDetailsList.conFclBLNonUsId != "" &&
          this.BLDetailsList.conFclBLNonUsId != undefined
        ) {
          this.prevBlStage = this.BLDetailsList.blStage;
        }
      }
      let arrayFilter = this.nonUsBlTable.filter(x => {
        return x.conFclBLNonUsId == item.conFclBLNonUsId;
      });

      this.BLRaised.notifyList = [];
      Object.keys(this.BLRaised).map(x => {
        if (x == "notifyList") {
          item[x].split("$$$").map((y, index) => {
            let obj = {
              inputValue: y,
              text: this.notifyListArray[index]
            };

            this.BLRaised.notifyList.push(obj);
          });
        } else {
          this.BLRaised[x] = item[x] || "";
        }
      });
      this.BLRaised.createUpdate = item.UpdatedDate
        ? item.UpdatedDate
        : item.CreatedDate;
      this.BLRaised.CreatedBY = item.UpdatedBY
        ? item.UpdatedBY
        : item.CreatedBY;
    },
    Print(item) {
      // window.open(`${this.docURL}/BL_CON/` + item);

      // console.log("BlRaised => ",this.BLRaised);
      this.BLRaised.ffExportFclConsoSeries =
        this.BLRaised.ffExportFclConsoSeries != ""
          ? this.BLRaised.ffExportFclConsoSeries
          : this.assignmentNo;
      console.log("Assignment no => ", this.BLRaised.ffExportFclConsoSeries);
      if(!item) return;
      let key =
        "ASSIGNMENT_UPLOADS/" +
        this.BLRaised.ffExportFclConsoSeries.replaceAll("/", "_") +
        "/" +
        item;
      this.openSignedDocument(key);
    },
    validateBLRaised() {
      let validate_new = true;
      Object.keys(this.errorBLRaised).map((x, index) => {
        if (this.BLRaised[x] == "") {
          console.log(x);
          this.errorBLRaised[x] = this.arrayErrorBLRaised[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        console.log("1");
        this.validate = true;
      } else {
        console.log("2");
        this.validate = false;
      }
    },

    addBLRaised() {
      this.getAgentName();
      // console.log("Add function assignment => ");
      // alert(this.assignmentNo);
      this.BLRaised["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.BLRaised["ffConExecutionId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );
      this.BLRaised["conFclBookingId"] = this.$sessionsStorage.get(
        "editconFclBookingId"
      );
      this.BLRaised["containerDetail"] = this.containerDetail;

      this.BLRaised["assignmentNo"] = this.assignmentNo.replaceAll("/", "_");

      this.BLRaised["allModuleId"] = this.allModuleId;
      // Validate that at least one container is selected
      this.BLRaised["selectedContainersData"] = this.getSelectedContainers();
      // Save selected container IDs as comma-separated string
      const selectedContainerIds = this.getSelectedContainerIds();
      this.BLRaised["selected_container"] = selectedContainerIds.join(',');
      if (!this.validateContainerSelection()) {
        return false;
      }
      this.validateBLRaised();

      this.BLRaised["isConsolidation"] = 1;

      console.log("BL => ", this.BLRaised);

      if (this.validate != false) {
        console.log("test");
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConBlNonUs_test.php`,
          data: JSON.stringify(this.BLRaised),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.BLRaised.conFclBLNonUsId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }

              Object.keys(this.BLRaised).map(x => {
                this.BLRaised[x] = "";
              });

              this.BLRaised.notifyList = [
                {
                  inputValue: "",
                  text: ""
                },
                {
                  inputValue: "",
                  text: "Second"
                }
              ];
              this.$refs["addPop"].open();

              this.getData();
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },
    getNoteData(noteTypeId) {
      const data = {
        allModuleId: this.allModuleId,
        categoryType: "NoteData",
        noteTypeId: noteTypeId
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getNoteData.php`,
        data: JSON.stringify(data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options).then(result => {
        const { statusText, status, data } = result;
        console.log(data);
        if (data.list.length > 0) {
          this.noteModal.approvalStatus = data.list[0].approvalStatus;
          this.noteModal.sentForApproval = data.list[0].sentForApproval;
          this.noteContent = data.list[0].noteContent;
          this.noteModal.uploadCreditDebit = data.list[0].uploadCreditDebit;
          this.noteAmount = data.list[0].noteAmount;
          this.note_id = data.list[0].note_id;
          this.noteModal.remarks = data.list[0].remarks;
          this.noteModal.AgentColoader = data.list[0].AgentColoader;
          this.noteModal.noteDate = data.list[0].noteDate;
        }
      });
    },
    getAgentColoaderList() {
      let type_Size = {
        view: "jdjd"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/getAgentColoaderList.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options).then(result => {
        const { statusText, status, data } = result;
        if (status == 200 && data) {
          this.AgentColoaderList = data.agentColoaderList;
        }
      });
    },
    getData() {
      this.doLoading();
      let type_Size = {
        itemCode: "itemCode",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId: this.$sessionsStorage.get("editconFclBookingId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/consofclBlNonUsGetData.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          console.log(data);
          if (status == 200 && data) {
            if (data.branchName.length > 0) {
              this.PlaceListNew = data.branchName;
            }

            if (data.allContainer.length > 0) {
              this.containerDetail = data.allContainer;
            }
            if (data.agentList.length > 0) {
              this.AgentList = data.agentList;
            }
            console.log("Happy=>", this.BLRaised);
            this.BLRaised.ffExportFclConsoSeries =
              data.stuffingData[0].ffExportFclConsoSeries || "";
            this.assignmentNo =
              data.stuffingData[0].ffExportFclConsoSeries || "";
            // alert(data.stuffingData.length)
            if (data.stuffingData.length > 0) {
              this.allData = data.stuffingData;
              this.allModuleId = data.stuffingData[0].allModuleId;
              this.BLRaised.allModuleId = data.stuffingData[0].allModuleId;
              // this.BLRaised.fclBlId = data.stuffingData[0].conFclBLNonUsId;
              this.BLNO = data.BLNO;
              this.BLRaised.placeReceipt = data.stuffingData[0].valPOR;
              this.BLRaised.portLoad = data.stuffingData[0].valLP;
              this.BLRaised.portDischarge = data.stuffingData[0].valPodLocation;
              this.BLRaised.placeDilievery = data.stuffingData[0].valFinal;
              this.BLRaised.bookingNo = data.stuffingData[0].bookingNumber;
              this.BLRaised.typeMove = data.stuffingData[0].deliveryMode;
              this.BLRaised.clientName = data.stuffingData[0].clientName;
              console.log(this.BLRaised.clientName, this.BLRaised.portLoad);
              this.preAlertData["ffFclConsoExportId"] =
                data.stuffingData[0].ffFclConsoExportId;
              this.preAlertData["fclConAlertId"] =
                data.stuffingData[0].fclConAlertId;
              console.log("Happy Singh Data=>", data);
              this.BLRaised.shippingLine = data.stuffingData[0].shippingLine;
              this.preAlertData["shippingLine"] = data.stuffingData[0].shippingLine;
              this.BLRaised.delieveryAgent =
                data.stuffingData[0].overseas_agent;
              this.BLRaised.house_bl_no = data.stuffingData[0].house_bl_no;
              this.BLRaised.master_bl_no = data.stuffingData[0].master_bl_no;
            }
            console.log("Assignment No => ", this.assignmentNo);

            if (data.clientNamesDetails.length > 0) {
              this.BLRaised.billLading =
                data.UserData[0].BranchCode +
                data.stuffingData[0].portCode.replace(/\s+/g, "") +
                data.BLMainNo;

              // this.BLRaised.billLading =
              //   data.UserData[0].BranchCode +
              //   data.stuffingData[0].portCode.replace(/\s+/g, "");

              this.getCLientData = data.clientNamesDetails;
              this.BLRaised.placeReceipt = data.stuffingData[0].valPOR;
              this.BLRaised.portLoad = data.stuffingData[0].valLP;
              this.BLRaised.portDischarge = data.stuffingData[0].valPodLocation;
              this.BLRaised.placeDilievery = data.stuffingData[0].valFinal;
              this.BLRaised.bookingNo = data.stuffingData[0].bookingNumber;
              this.BLRaised.typeMove = data.stuffingData[0].deliveryMode;
            } else {
              this.getCLientData = [];
            }
            // Added By Priyanshu Singh Start
            // if (data.ConBLNonUsData.length > 0) {
            //   if (data.ConBLNonUsData[0].loginTime) {
            //     this.BLRaised.blCreatedDate = data.ConBLNonUsData[0].loginTime.split(" ")[0];
            //   }
            //   this.BLDetailsList = data.ConBLNonUsData;
            //   console.log("PRIY=>",this.BLDetailsList);
            //   if(this.BLDetailsList.length>0 && (this.BLDetailsList[0].blStage=='ORIGINAL' || this.BLDetailsList[0].blStage=='SEAWAY') ){
            //     this.originalDone=true;
            //     this.BLRaised.blStage=""
            //     if(this.BLDetailsList[0].mail_approved_status=='1'){
            //       this.originalDone=false;
            //     }
            //   }
            //   if(this.BLDetailsList.length>0 ){
            //     this.prevBlStage = this.BLDetailsList[0].blStage;
            //   }
            // }
            // Added By Priyanshu Singh End
            if (data.ConBLNonUsData.length > 0) {
              this.BLRaised.selected_container =data.ConBLNonUsData[0].selected_container;
              this.BLRaised.portLocationType =
                data.ConBLNonUsData[0].portLocationType;
              this.nonUsBlTable = data.ConBLNonUsData;
              if (data.ConBLNonUsData[0].placeBranch) {
                this.noteModal.branchList = data.ConBLNonUsData[0].placeBranch;
                if (data.ConBLNonUsData[0].clientName) {
                  data.branchName.forEach(e => {
                    if (e.pickupId == data.UserData[0].baseLocation) {
                      console.log(e.pickupLocation);
                      this.noteModal.branchName = e.pickupLocation;
                    }
                  });
                }
              }
              this.noteModal.clientName = data.ConBLNonUsData[0].clientName;

              data.ConBLNonUsData.forEach(item => { 
                this.preAlertData["vesselVoy"] += item.vesselVoy + " , ";
                this.preAlertData["shipper_name"] += item.clientName + " , ";
                this.preAlertData["consignee"] +=
                  this.removeTags(item.consignee) + " , ";

                this.preAlertData["house_bl_no"] += item.billLading + " , ";
              });
              
              let shipper_name = this.preAlertData.shipper_name.replace(/ /g, " ").split(",");
              console.log("shipper_name", shipper_name);
              shipper_name = [...new Set(shipper_name)];
              console.log("shipper_name", shipper_name);
              this.preAlertData.shipper_name = "";
              this.preAlertData.shipper_name = shipper_name.join(",");

              let consignee = this.preAlertData.consignee.replace(/ /g, " ").split(",");
              console.log("consignee", consignee);
              consignee = [...new Set(consignee)];
              console.log("consignee", consignee);
              this.preAlertData.consignee = "";
              this.preAlertData.consignee = consignee.join(",");

              let vesselVoy = this.preAlertData.vesselVoy.replace(/ /g, " ").split(",");
              console.log("vesselVoy", vesselVoy);
              vesselVoy = [...new Set(vesselVoy)];
              console.log("vesselVoy", vesselVoy);
              this.preAlertData.agent_reference_id = "";
              this.preAlertData.vesselVoy = "";
              this.preAlertData.vesselVoy = vesselVoy.join(",");

              let house_bl_no = this.preAlertData.house_bl_no.replace(/ /g, " ").split(",");
              console.log("house_bl_no", house_bl_no);
              house_bl_no = [...new Set(house_bl_no)];
              console.log("house_bl_no", house_bl_no);
              this.preAlertData.house_bl_no = "";
              this.preAlertData.house_bl_no = house_bl_no.join(",");
            }
            if (data.ConBLNonUsData && data.ConBLNonUsData.selected_container) {
              this.autoSelectContainersFromData(data.ConBLNonUsData.selected_container);
            }
            this.getAgentColoaderList();
            this.getTrackingDetails();
            if (data.stuffingData.length > 0) {
              this.BLRaised.shippingLine = data.stuffingData[0].shippingLine;
            }
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },
     // Method to auto-select containers from saved data
    autoSelectContainersFromData(selectedContainerData) {
      console.log("priyanshu Singh containerIds1=>", selectedContainerData);
      console.log("priyanshu Singh containerTypeDetailFactory1=>", this.containerDetail);
      if (!selectedContainerData || !this.containerDetail.length) {
        return;
      }
     
      
      try {
        // Clear all current selections first
        this.containerDetail.forEach(container => {
          container.selected = false;
        });
        
        // Handle comma-separated string format (e.g., "167477, 167478, ")
        if (typeof selectedContainerData === 'string') {
          // Split by comma and clean up whitespace and empty values
          const containerIds = selectedContainerData
            .split(',')
            .map(id => id.trim())
            .filter(id => id !== '' && id !== null && id !== undefined);
            console.log("priyanshu Singh containerIds=>", containerIds);
            console.log("priyanshu Singh containerDetail=>", this.containerDetail);
          // Select containers based on uniqueContainerId
          containerIds.forEach(containerId => {
            const container = this.containerDetail.find(item => 
              item.uniqueContainerId == containerId
            );
            
            if (container && container.containerWithSplit != 1) {
              container.selected = true;
            }
          });
        }
        
        // Update the select all state
        this.updateSelectAll();
        
        console.log('Auto-selected containers from saved data:', selectedContainerData);
      } catch (error) {
        console.error('Error auto-selecting containers:', error);
      }
    },
    
    removeTags(str) {
      if (str === null || str === "") return false;
      else str = str.toString();

      // Regular expression to identify HTML tags in
      // the input string. Replacing the identified
      // HTML tag with a null string.
      return str.replace(/(<([^>]+)>)/gi, "");
    },
    getTrackingDetails() {
      let new_data = {
        allModuleId: this.allModuleId
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
          }
        })
        .catch(error => {});
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },

    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/ffExportCon/conFclBLofLanding"
      // });
    },
    proceedAws() {
      this.$sessionsStorage.set("blType", "house");
      this.$sessionsStorage.set("ffType", "fclcon");
      this.$router.push({
        path: "/ffExportCon/conAmsFilling"
      });
    },

    validateVGM() {
      let validate_new = true;
      Object.keys(this.errorVgmList).map((x, index) => {
        if (this.vgmModel[x] == "") {
          this.errorVgmList[x] = this.arrayErrorVgm[index];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },

    onClose(type) {}
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// conBLNewNonUs.vue?53b829bb